import { BookMarked,LayoutList } from 'lucide-react';
import React, { useState, useEffect,useMemo} from 'react';

const ListaMaterias = ({ materias, isSuperView}) => {

  // 1. Agrupar materias por categoría usando useMemo
  // Esto evita que se recalcule en cada renderizado
  const materiasAgrupadas = useMemo(() => {
    if (!materias || materias.length === 0) {
      return {}; // Devuelve un objeto vacío si no hay materias
    }
    
    // Usamos 'reduce' para transformar el array en un objeto de categorías
    // { "Matemáticas": [materia1, materia2], "Programación": [materia3] }
    return materias.reduce((acc, materia) => {
      const categoria = materia.categoria || 'Sin Categoría';
      
      if (!acc[categoria]) {
        acc[categoria] = []; // Si la categoría no existe en el acumulador, la crea
      }
      
      acc[categoria].push(materia); // Agrega la materia a su categoría
      return acc;
    }, {}); // El {} es el valor inicial (un objeto vacío)

  }, [materias]); // Esta función solo se vuelve a ejecutar si la prop 'materias' cambia

  // Obtenemos los nombres de las categorías (ej: ["Matemáticas", "Programación"])
  const categorias = Object.keys(materiasAgrupadas);
  const hayMaterias = categorias.length > 0;

  return (
    <div className="space-y-4">

      {hayMaterias ? (
        // 2. Contenedor para todas las categorías
        <div className="space-y-5">
          
          {/* 3. Mapear cada categoría */}
          {categorias.map(categoria => (
            <div key={categoria} className="border-b last:border-b-0 pb-4">
              
              {/* Nombre de la Categoría */}
              <h3 className="font-semibold text-lg text-gray-700 mb-2">
                {categoria}
              </h3>
              
              {/* 4. Lista (ul) de materias para esa categoría */}
              <ul className="list-disc list-inside space-y-1 pl-4">
                {materiasAgrupadas[categoria].map((materia, idx) => (
                  <li 
                    key={materia.nombremateria || idx} 
                    className="text-gray-600"
                  >
                    {materia.nombremateria}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      ) : (
        // Mensaje si no hay materias
        <div className="text-gray-500 italic">
          No hay materias seleccionadas.
        </div>
      )}
      
    </div>
  );
};

export default ListaMaterias;